<div class="switch-card mb-2" #switchCardContainer>
  <div class="switch-card-header-wrapper">
    <!-- <div [id]="id" [class]="styleLeftCol" [ngClass]="{ 'pr-1 pt-0 pl-0 pb-0 switch-card-heading': true, pointer: isAccordin }" (click)="toggleAccordin()"></div> -->
    <div class="switch-card-heading">
      <!-- <i class="fal fa-chevron-right" *ngIf="showAccordinIcon && !isAccordinOpen"></i>
      <i class="fal fa-chevron-down" *ngIf="showAccordinIcon && isAccordinOpen"></i> -->
      {{ heading }}
    </div>
    <span *ngIf="isDataLoading">
      <i class="fal fa-spinner rotate"></i>
    </span>
    <div *ngIf="!isDataLoading" class="custom-switch-pill">
      <div *ngIf="!isFetching && defaultSchedulePickUpState !== isSchedulePickUp" tooltipPosition="bottom" tooltipStyleClass="tech-inprogress-tooltip font-10" pTooltip="Select to set current selection as your default choice.">
        <app-checkbox inputId="cb-sms-template" label="Set as default?" [fontSize]="10" (appChange)="updateScheduleSettings()">
        </app-checkbox>
      </div>
      <div class="font-10 switch-saved" *ngIf="showSaved">
        <i class="fal fa-check"></i>
        Saved!
      </div>
      <label class="ml-2 switch switch-pill switch-success" [ngStyle]="{ fontSize: fontSize + 'px' }">
        <input type="checkbox" name="displayMessage" class="switch-input" [(ngModel)]="active" (ngModelChange)="onModelChange($event)" />
        <span class="switch-slider"></span>
      </label>
    </div>
  </div>

  <span *ngIf="!hasCustomTemplate">
    <div class="ui-g" *ngIf="isAccordinOpen">
      <div class="ui-g-12 pr-1 pl-0 switch-sub-heading">{{ content }}</div>
    </div>
  </span>

  <div [ngClass]="{ 'display-block': hasCustomTemplate, 'display-none': !hasCustomTemplate }">
    <div *ngIf="isAccordinOpen">
      <ng-container *ngTemplateOutlet="overlayTemplate"> </ng-container>
    </div>
  </div>
</div>
